// __VERSION__ is injected by babel-plugin-version-inline
// @ts-ignore TS2304: Cannot find name '__VERSION__'.
const VERSION = typeof "4.2.1" !== 'undefined' ? "4.2.1" : 'latest';
/**
 * Loader for the MTL material format
 * Parses a Wavefront .mtl file specifying materials
 */
export const MTLLoader = {
    dataType: null,
    batchType: null,
    name: 'MTL',
    id: 'mtl',
    module: 'mtl',
    version: VERSION,
    worker: true,
    extensions: ['mtl'],
    mimeTypes: ['text/plain'],
    testText: (text) => text.includes('newmtl'),
    options: {
        mtl: {}
    }
};
